<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="main_content">
        <div class="tit">商品生产组码设置</div>

        <div class="block">
          <h1><span class="mark">*</span>属性标签&属性标签值</h1>
          <!-- <div class="input_box flex-between" @click="handlePopup(1)">
            <van-field
              v-model="attrStr"
              placeholder="请选择属性标签&属性标签值"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div> -->
          <div
            class="shop_attr_column"
            v-for="(item, index) in shopAttr"
            :key="index"
          >
            <div class="tit">{{ item.attrname }}</div>
            <div class="select_list flex-rowl">
              <div
                v-for="(itemChild, indexChild) in item.items"
                :key="indexChild"
                @click="handleSelectAttr(item, itemChild, index)"
                class="select_item flex-between"
                :class="selectIndexObj['select' + itemChild.attrid] ==
                      item.attrname + '-' + itemChild.attrvalue"
              >
                <span class="txt">{{ itemChild.attrvalue }}</span>
                <span
                  v-if="selectIndexObj['select' + itemChild.attrid] ==
                      item.attrname + '-' + itemChild.attrvalue"
                  class="iconfont icon-3tuihuanhuozhengcegouxuan"
                ></span>
              </div>
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>生产商</h1>
          <div class="input_box flex-between" @click="handlePopup(2)">
            <van-field
              v-model="productStr"
              placeholder="请选择属性标签&属性标签值"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>投产时间</h1>
          <div class="input_box flex-between" @click="handlePopup(3)">
            <van-field
              v-model="formData.startdate"
              placeholder="请选择投产时间"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>预期生产数量</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.plannum"
              placeholder="请输入预期生产数量"
            />
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择属性标签&属性标签值"
          show-toolbar
          :columns="attrList"
          @confirm="onConfirm"
          value-key="msg"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择生产商"
          show-toolbar
          :columns="supplierList"
          @confirm="onConfirm"
          value-key="labelname"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 3">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          title="选择年月日"
          :formatter="formatter"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import {
  getCommondityLabelList,
  encryptstringview,
  getCommidityDetail,
  getSupplierList,
} from "../../../api/api";
import {
  editShopProductionCode,
  addShopProductionCode,
  getShopProductionCodeDetail,
} from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cProductionCodeSet",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      // 弹窗
      popupType: 1,
      isShow: false,

      attrList: [], // 属性列表
      id: "", // 属性id
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "",
        id: "",
        sku: "",
        attrid: "",
        productid: "",
        startdate: "",
        plannum: "",
      },
      attrStr: "",
      productStr: "",
      supplierParams: {
        qyid: 0,
        Page: 1,
        PageSize: 50,
        keyword: "",
      },
      supplierList: [],
      currentDate: new Date(),
      shopAttr: [],
      selectIndexObj: {
        attrItem: [],
        arrItem: [],
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    if (USERINFO.qy) {
      this.supplierParams.qyid = USERINFO.qy.id;
    } else {
      this.supplierParams.qyid = 0;
    }
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmid, id } = JSON.parse(res.jsondata);
        this.formData.cmid = cmid;
        this.formData.id = id;
        if (id) {
          this.getShopProductionCodeDetail();
        }
        this.getCommidityDetail(cmid);
        this.getAtrrList(cmid);
        this.getSupplierList();
      } else {
        this.$router.back();
      }
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },

    // 获取商品详情
    getCommidityDetail(id) {
      getCommidityDetail({ id }).then((res) => {
        this.formData.sku = res.sku;
        this.shopAttr = res.attr;
      });
    },

    getShopProductionCodeDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { id } = this.formData;
      getShopProductionCodeDetail({ id }).then((res) => {
        // this.formData = res;
        let splitStartdate = res.startdate.split("T");
        this.formData.attrid = res.attrid;
        this.formData.productid = res.productid;
        this.formData.startdate = splitStartdate[0] + " " + splitStartdate[1];
        this.formData.plannum = res.plannum;
        this.productStr = res.productidstr;
        this.attrStr = res.attrname + " " + res.attrvalue;
        res.attridstr.map((v) => {
          this.$set(
            this.selectIndexObj,
            `select${v.attrnameid}`,
            v.attrname + "-" + v.attrvalue
          );
        });
        Toast.clear();
      });
    },

    // 获取生厂商
    getSupplierList() {
      let { supplierParams } = this;
      getSupplierList(supplierParams).then((res) => {
        // 按时间降序
        // dataNew.sort((a, b) => b.createdate.localeCompare(a.createdate))
        let newRes = res.filter((v) => v.labelstate == 1);
        this.supplierList = newRes;
      });
    },
    // 操作商品的属性
    handleSelectAttr(item, itemChild, index) {
     this.selectIndexObj.arrItem[index] = itemChild;
      this.selectIndexObj.attrItem[index] =
        item.attrname + ":" + itemChild.attrvalue;
      this.$set(
        this.selectIndexObj,
        `select${item.attrid}`,
        item.attrname + "-" + itemChild.attrvalue
      );
    },

    // 获取属性标签
    getAtrrList(cmid) {
      let params = {
        cmid,
        keyword: "",
      };
      getCommondityLabelList(params).then((res) => {
        res.forEach((v) => {
          v.msg = v.attrname + " " + v.attrvalue;
        });
        this.attrList = res;
      });
    },

    handlePopup(type) {
      this.popupType = type;
      this.isShow = true;
    },
    // 显示弹窗
    onConfirm(e) {
      let { popupType } = this;
      if (popupType == 1) {
        this.formData.attrid = e.id;
        this.attrStr = e.attrname + " " + e.attrvalue;
      } else if (popupType == 2) {
        this.formData.productid = e.id;
        this.productStr = e.labelname;
      } else {
        let data = new Date(e);
        let year = data.getFullYear();
        let month = data.getMonth() + 1;
        let months = month < 10 ? "0" + month : month;
        let day = data.getDate() < 10 ? "0" + data.getDate() : data.getDate();
        let hh = data.getHours() < 10 ? "0" + data.getHours() : data.getHours();
        let mm =
          data.getMinutes() < 10 ? "0" + data.getMinutes() : data.getMinutes();
        let str =
          year + "-" + months + "-" + day + " " + hh + ":" + mm + ":" + "00";
        this.formData.startdate = str;
      }

      this.isShow = false;
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    // 输入框限制
    handleInputPrice(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.num = value;
    },
    handleReturn() {
      history.back();
    },

    query() {
      let { formData, selectIndexObj, shopAttr  } = this;
       if (shopAttr.length != selectIndexObj.arrItem.length) {
        this.$toast("请选择属性标签&属性标签值");
        return;
      }
      let attrStr = selectIndexObj.arrItem.map((item) => item.id).join(",");
      formData.attrid = attrStr;
      let params = formData;
      if (formData.startdate == "") {
        this.$toast("请选择投产时间");
        return false;
      }
      if (formData.plannum == "") {
        this.$toast("请填写预期生产数量");
        return false;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (formData.id) {
        editShopProductionCode(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopProductionCode(params).then((res) => {
          let data = res;
          if (data.result) {
            // setTimeout(() => {
            //   Toast.clear();
            //   this.$toast.success(data.message);
            // }, 2000);
            setTimeout(() => {
              Toast.clear();
              history.back();
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-top: 120px;
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .shop_attr_column {
    width: 600px;
    margin: 20px auto 30px;
    .tit {
      font-size: 26px;
      color: #3c3c3c;
      position: relative;
      margin: 0 0 30px;
      text-align: left;
      &::before {
        position: absolute;
        width: 4px;
        height: 25px;
        top: 50%;
        transform: translateY(-50%);
        background: #ff0042;
        display: inline-block;
        content: "";
        left: -15px;
      }
    }
    .select_list {
      flex-wrap: wrap;
      .select_item {
        padding: 0 15px 0 17px;
        background: #f5f5f5;
        border-radius: 15px;
        font-size: 22px;
        color: #3c3c3c;
        margin: 0 20px 20px 0;
        position: relative;
        min-width: 125px;
        border: 3px solid #f5f5f5;
        box-sizing: border-box;
        cursor: pointer;
        height: 50px;
        &.active {
          background: #fff;
          border: 2px solid #f5f5f5;
          box-sizing: border-box;
        }
        .icon-3tuihuanhuozhengcegouxuan {
          font-size: 32px;
          color: #ff0042;
        }
      }
    }
  }
}
</style>